<template>
  <header
    class="header"
    :class="{ header_nav_active: isMenuOpen }"
  >
    <div class="header__inner">
      <div class="header__progress">
        <BaseProgress :percent="progress" :count="progressCount" />
      </div>
      <div class="header__nav">
        <BaseBurger
          class="header__burger"
          :is-active="isMenuOpen"
          is-round
          @click="showMenu"
        />
        <ul v-if="isMenuOpen" class="header__menu">
          <li
            v-for="(item, index) in menu"
            :key="`menu_item_${index}`"
            class="header__menu-item"
            data-animation="fadeInRight"
            :data-animation-delay="100 + (index * 200)"
          >
            <router-link :to="item.path" class="header__link" v-html="item.meta.menu" @click.native="hideMenu" />
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
import { mapState } from 'vuex';
import { slides } from '@/router/index';

import BaseBurger from '@/components/BaseBurger.vue';
import BaseProgress from '@/components/BaseProgress.vue';

export default {
  name: 'TheHeader',
  components: {
    BaseBurger,
    BaseProgress,
  },
  data() {
    return {
      isMenuOpen: false,
    };
  },
  staticData: () => ({
    menu: slides.filter((slide) => slide.meta && slide.meta.menu),
  }),
  computed: {
    ...mapState(['progress', 'progressCount']),
  },
  created() {
    document.addEventListener('click', this.checkClick);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.checkClick);
  },
  methods: {
    checkClick(e) {
      if (e.target.closest('.header__nav')) return;
      this.hideMenu();
    },
    showMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    hideMenu() {
      this.isMenuOpen = false;
    },
  },
};
</script>

<style lang="stylus">
.header
  display block
  color #000
  +portrait()
    background #f9f9f9
    box-shadow 0 0.25em 1em rgba(0, 0, 0, 0.15)
    border-radius 0 0 1.25em 1.25em
    &_nav_active
      box-shadow 0 0 0 100vmax rgba(0, 0, 0, 0.5)

  &__inner
    +portrait()
      padding-left 1.4em
      padding-right @padding-left
    +landscape()
      padding-top 0.5em
      padding-bottom @padding-top
      padding-left 2em
      padding-right @padding-left

  &__progress
    +portrait()
      padding-right 3em
      padding-top 1.7em
      padding-bottom 1em
    +landscape()
      display none

  &__nav
    +landscape()
      position relative
      width 2em
      margin-left auto
      pointer-events auto

  &__burger
    +portrait()
      abs top right
      margin 0.4em 1em

  &__menu
    +portrait()
      display block
      list-style none
      padding 1.5em 0 2em 0
      margin 0.7em 0 0 0
      font-size 1.15em
      border-top solid 1px alpha($c_border, 30%)
    +landscape()
      display block
      list-style none
      abs top 120% right
      width 15em
      visibility hidden
      opacity 0
      margin 0
      padding 1.25em 1.5em
      background-color #fff
      color $c_text
      box-shadow 0 0 1em rgba(0, 0, 0, 0.07)
      transition opacity 200ms, transform 200ms cubic-bezier(0.33, 1, 0.68, 1)
      transform translate(0, 1em)
      border-radius 0.5em
      z-index 10
      ~/_nav_active &
        visibility visible
        opacity 1
        transform translate(0,0)

  &__menu-item
    font-size 0.8em
    line-height 1.2
    margin-top 1.2em
    &:first-child
      margin-top 0

  &__link
    display inline-block
    vertical-align top
    color inherit
    text-decoration none
    &:before
      content '\25CF'
      font-family Arial
      display none
      margin-right 0.5em
      color $c_bright
    &:hover
      color $c_link
    &._active_exact
      font-weight 700
      pointer-events none
      color #000
      &:before
        display inline
</style>
